<ng-container *ngIf="database?.status?.status === 'ok'">
    <app-platform-health-indicator label="CPU media de la BD"
        helpText="CPU media de la base de datos durante el periodo. Si la base está dentro de un pool elástico, el porcentaje es relativo al pool y no a la base.">
        {{ avgOf(database?.series, 'cpu_percent') | number:'1.0-0' }}%
    </app-platform-health-indicator>

    <app-platform-health-indicator label="CPU máx. de la BD"
        helpText="Pico de CPU de la base de datos. Igual que la media, si la base está en un pool el porcentaje es relativo al pool.">
        {{ maxOf(database?.series, 'cpu_percent') | number:'1.0-0' }}%
    </app-platform-health-indicator>

    <app-platform-health-indicator label="Workers máx."
        helpText="Pico de uso de los workers de SQL Server, que son los hilos que ejecutan las peticiones. Es lo más parecido a una cola que tiene la base: si se agotan, las consultas esperan.">
        {{ maxOf(database?.series, 'workers_percent') | number:'1.0-0' }}%
    </app-platform-health-indicator>
</ng-container>
